{
  "SET_NEW_PASSWORD": {
    "TITLE": "Set new password",
    "PASSWORD": {
      "LABEL": "Passord",
      "PLACEHOLDER": "Passord",
      "ERROR": "Passordet er for kort."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm password",
      "PLACEHOLDER": "Bekreft passord",
      "ERROR": "Passordet stemmer ikke."
    },
    "API": {
      "SUCCESS_MESSAGE": "Passordet ble endret.",
      "ERROR_MESSAGE": "Could not connect to chat server. Please try again."
    },
    "CAPTCHA": {
      "ERROR": "Verification expired. Please solve captcha again."
    },
    "SUBMIT": "Send"
  }
}
